'use strict';

const htmlToPlaintext = require('../../../functions/htmlToPlaintext');

angular.module('rmApp')
    .filter('htmlToPlaintext', () => htmlToPlaintext)
    .filter('ordinal', ['moment', function (moment) {
        return function (input, lang) {
            if (lang) {
                return moment.localeData(lang).ordinal(parseInt(input));
            } else {
                return moment.localeData().ordinal(parseInt(input));
            }
        }
    }])
    .filter('replaceUrls', function () {

        var urls = /(\b(https?|ftp):\/\/[A-Z0-9+&@#\/%?=~_|!:,.;-]*[-A-Z0-9+&@#\/%=~_|])/gim;
        var emails = /(\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,6})/gim;

        return function (text, lang) {
            if (text.match(urls)) {
                text = text.replace(urls, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>');
            }
            if (text.match(emails)) {
                text = text.replace(emails, '<a href=\"mailto:$1\" rel="noopener noreferrer">$1</a>');
            }
            return text;
        }
    })
;
